import { QueryClient } from "@tanstack/react-query";
import axios, { type AxiosRequestHeaders } from "axios";

import { reactQueryConfig } from "@configs";
import { useUserStore } from "@/stores/userStore";
import { useUiStore } from "@/stores/uiStore";

const baseURL = import.meta.env.VITE_API_BASE_URL;

if (baseURL === undefined) {
  throw new Error(
    "API base URL not found, maybe forgot to set env var VITE_API_BASE_URL?",
  );
}

// Create an Axios instance with the base URL from your environment variables
const axiosClient = axios.create({ baseURL });

// Set up a request interceptor to add the Authorization header dynamically
axiosClient.interceptors.request.use((config) => {
  const state = useUserStore.getState();
  const language = useUiStore.getState().locale;

  // Ensure headers exist and are properly typed

  if (!config.url?.includes("http")) {
    config.headers = (config.headers as AxiosRequestHeaders) || {};

    if (state.token) {
      config.headers.Authorization = `Bearer ${state.token}`;
    }

    config.headers["X-Accept-Language"] = language;
  }

  return config;
});

const queryClient = new QueryClient(reactQueryConfig);

export { axiosClient, queryClient };
